<template>
    <div>
        <div style="height: 20vh;" class="inapp-hide"></div>
        <Riassunto :iscrizione="false"/>
        <div class="race-app-header inapp-show"></div>
        <div class="v-step step" v-bind:class="{ 'active': step === 0 }"
             @click="focusStep">
            <div>
                <b-input type="search"
                         v-model="ricerca"
                         placeholder="Cerca il team che vuoi sostenere"
                         @input="change_team"
                         :class="{loading: team_loading}"></b-input>
                <span v-if="count > 0">
                <table class="table mt-6">
                    <thead>
                    <tr class="text-uppercase small">
                        <th>Team</th>
                        <th>Capitano</th>
                        <th>Membri</th>
                        <th>Tipologia</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="team in teams" :key="team.id" class="small border-bottom">
                        <td class="font-weight-bold h6">
                            <div><a :href=team_url(team) class="text-dark" target="_blank">{{ team.name }}</a></div>
                            <a class="button-join no-border text-dark arrow" :href=team_url(team) target="_blank">Dettagli</a>
                        </td>
                        <td v-if="team.capitano_pubblico">{{ team.capitano}}</td>
                        <td v-if="!team.capitano_pubblico"><img height="15"
                                     src="/static/svg/icons/icon-not-visible-white.svg"></td>
                        <td>
                            <span v-if="team.num_membri < 15">N/D</span>
                            <span v-if="team.num_membri >= 15">{{ team.num_membri }}</span>
                        </td>
                        <td class="font-italic"><div class="icon-group" :class="team.tipo" v-b-tooltip.hover
                                                     :title="team.tipo_esteso"></div></td>
                        <td>
                            <span v-if="team.limite_membri <= team.num_membri">
                                Gruppo Pieno
                            </span>
                            <a class="button-join" role="button" @click="submit(team)">Sostieni</a>
                        </td>
                    </tr>
                    <tr v-if="count < tot" class="text-center text-uppercase small">
                        <td colspan="4" class="small py-4">{{count}} team di {{tot}}</td>
                    </tr>
                    </tbody>
                </table>
                </span>
                <!-- Todo: questo span si vede decisamente male -->
                <span v-if="count <=0 && count !== null" class="text-center w-100 h5 pb-4 d-block"><span class="pb-4">Al momento, non sono presenti team per questa gara.</span></span>

                <div class="text-center d-flex align-items-center justify-content-center">
                    <nav aria-label="Page navigation example">
                        <ul class="pagination pagination-sm">
                            <li class="page-item" v-if="has_prev"><a class="page-link bg-transparent" @click="prev()">&laquo;</a>
                            </li>
                            <li class="page-item active" v-if="has_prev || has_next"><a class="page-link rounded">{{
                                show_page }}</a></li>
                            <li class="page-item" v-if="has_next"><a class="page-link bg-transparent" @click="next()">&raquo;</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
        <div class="v-step__next">
            <div class="v-step__next__title">Non hai trovato il team che vuoi?</div>
            <div class="d-inline-block mt-2">Fai una donazione..</div>
        </div>
        <div style="height: 30vh;"></div>
    </div>
</template>

<script>
    import BaseForm from "../BaseForm";
    import debounce from 'lodash/debounce'
    import Riassunto from "./Riassunto";

    export default {
        name: "SostieniSquadra",
        extends: BaseForm,
        components: {Riassunto},
        async mounted() {
            await this.$nextTick()
            this.id_race = this.$store.state.id_race
            this.load_data('')
        },
        data() {
            return {
                teams: false,
                team_loading: false,
                ricerca: null,
                id_race: null,
                count: null,
                tot: 0,
                num_per_page: 5,
                page: 1,
                has_next: false,
                has_prev: false,
                num_pages: 1,
                show_page: 1,
                pass_loading: false,
                password: null,
                team_sel: null
            }
        }, methods: {
            submit(team) {
                // Verifico che tipo di team è
                if ((team.tipo === 'gruppo-aperto') || (team.tipo === 'gruppo-aperto-limitato')) {
                    this.$store.commit('team', team)
                    this.goTo('sostieni-inserimento-dati')
                }
            },
            change_team: debounce(function () {
                this.page = 1
                this.load_data(this.ricerca)
            }, 100),
            next() {
                if (!this.has_next) return false

                this.page++
                this.load_data(this.ricerca)
            },
            prev() {
                if (!this.has_prev) return false

                this.page--
                this.load_data(this.ricerca)
            },
            load_data(search) {

                this.team_loading = true;
                this.$http.get('/race/form/selezione_team/?type=table&id_race=' + this.id_race
                    + '&search=' + encodeURIComponent(search) + '&num_per_page='
                    + this.num_per_page
                    + '&page=' + this.page)
                    .then((response) => {
                        this.teams = response.data.teams
                        this.team_loading = false
                        this.count = this.teams.length
                        this.tot = response.data.tot
                        this.num_pages = response.data.num_pages
                        this.has_next = response.data.has_next
                        this.has_prev = response.data.has_prev
                        this.show_page = response.data.page
                    })
            }, team_url(team) {
                return '/race/team/' + this.id_race + '/detail/' + team.id
            }
        }
        ,
        computed: {}
    }
</script>

<style scoped>

</style>